
import React from 'react';
import {Overlay} from "../../components/modal";
import {DIALOG_STYLE} from "./common";
import {Times} from "../../funcs/utils";
import {sprintf} from "sprintf-js";

const render_header = (item, component) => {
  const on_close = () => {
    component.setState({
      show_purchase_modal: false,
    })
  }
  return (
    <div style={{display: "flex"}}>
      <div>
        State Restriction: { item.CUSIP }
      </div>
      <div style={{ flex: "1"}}/>
      <div onClick={on_close}>
        <Times/>
      </div>
    </div>);
}

const render_footer = component => {
  const client = component.props.client;
  const bg_color = client.color.sign_on_button;
  const button_style = {
    background: sprintf("rgba(%d, %d, %d", bg_color.r, bg_color.g, bg_color.b),
    width: "10rem",
    padding: "0.5rem 0"
  }
  const on_close = () => {
    component.setState({
      show_purchase_modal: false,
    })
  }
  return (
    <div
      onClick={on_close}
      style={{ display: "flex", marginTop: "2rem", justifyContent: "center"}}>
      <button style={button_style}>
        Ok
      </button>
    </div>);
}

const StateRestrictedModal = props => {
  const { item, component, restricted_states } = props;
  const state_str = restricted_states.join(", ");

  return (
    <Overlay>
      <div style={DIALOG_STYLE}>
        { render_header(item, component) }
        <div>
          <div style={{height: "1rem"}}/>
          <div align={"center"}>
            This CD is restricted in the following states:
          </div>
          <div style={{height: "1rem"}}/>
          <div align={"center"} style={{ fontWeight: "bold" }}>
            { state_str}
          </div>
          <div style={{height: "1rem"}}/>
          <div align={"center"}>Please choose another</div>
        </div>
        { render_footer(component) }
      </div>
    </Overlay>
  )
}

export { StateRestrictedModal };
